export default __webpack_public_path__ + "static/media/bg_result_lose_mobile.fdb7e7aa.png";